import * as types from '../constants/ActionTypes';

const initialState = {
  loginState: 'Number',
  number: null,
  isLoading: false,
  inviteData: null,
  inviteError: null,
  numberData: null,
  numberError: null,
  smsData: null,
  smsError: null,
  tokenData: null,
  tokenError: null,
  restoreData: null,
  restoreError: null,
  reconnectData: null,
  reconnectError: null,
};

export default function loginForms(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case types.INVITE_FORM_SENDING_START:
      return { ...state, isLoading: true };
    case types.INVITE_FORM_SENDING_SUCCESS:
      return { ...state, isLoading: false, inviteData: payload };
    case types.INVITE_FORM_SENDING_ERROR:
      return { ...state, isLoading: false, inviteError: payload };

    case types.NUMBER_FORM_SENDING_START:
      return { ...state, isLoading: true, number: payload, smsError: null, smsData: null };
    case types.NUMBER_FORM_SENDING_SUCCESS:
      return { ...state, isLoading: false, numberData: payload, loginState: 'SMS' };
    case types.NUMBER_FORM_SENDING_ERROR:
      return { ...state, isLoading: false, numberError: payload };

    case types.SMS_FORM_SENDING_START:
      return { ...state, isLoading: true };
    case types.SMS_FORM_SENDING_SUCCESS:
      return { ...state, /*isLoading: false,*/ smsData: payload, smsError: null };
    case types.SMS_FORM_SENDING_ERROR:
      return { ...state, isLoading: false, smsError: payload };

    case types.REQUEST_TOKEN_START:
      return { ...state, isLoading: true };
    case types.REQUEST_TOKEN_SUCCESS:
      return { ...state, isLoading: false, tokenData: payload };
    case types.REQUEST_TOKEN_ERROR:
      return { ...state, isLoading: false, tokenError: payload };

    case types.RESTORE_FORM_SENDING_START:
      return { ...state, isLoading: true };
    case types.RESTORE_FORM_SENDING_SUCCESS:
      return { ...state, isLoading: false, restoreData: payload };
    case types.RESTORE_FORM_SENDING_ERROR:
      return { ...state, isLoading: false, restoreError: payload };

    case types.RECONNECT_FORM_SENDING_START:
      return { ...state, isLoading: true };
    case types.RECONNECT_FORM_SENDING_SUCCESS:
      return { ...state, isLoading: false, reconnectData: payload };
    case types.RECONNECT_FORM_SENDING_ERROR:
      return { ...state, isLoading: false, reconnectError: payload };

    case types.USER_LOGOUT_START:
      return { ...state, isLoading: false, loginState: 'Number' };

    default:
      if (action.payload && action.payload.error) {
        console.error(action.payload.error)
      }
      if (
        action.payload &&
        action.payload.error &&
        action.payload.error.response &&
        action.payload.error.response.data.error['error-code'] === 'USER_HAS_NOT_PERMISSION'
      ) {
        return { ...state, isLoading: false, loginState: 'Number' };
      }
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loginForms.js